import apiClient from "./apiClient";
import { Warehouse } from "../types";

// Бэкенд может вернуть как массив, так и объект-обёртку
type WarehousesResponse = Warehouse[] | { warehouses: Warehouse[] };

interface DefaultWarehouseResponse {
  warehouse: Warehouse;
}

export const fetchDefaultWarehouse = async (): Promise<Warehouse> => {
  try {
    const response = await apiClient.get<DefaultWarehouseResponse>("/api/warehouses/default");
    return response.data.warehouse;
  } catch (error) {
    console.error("Ошибка при получении склада по умолчанию:", error);
    throw new Error("Не удалось получить склад по умолчанию");
  }
};

export const fetchAllWarehouses = async (): Promise<Warehouse[]> => {
  try {
    const response = await apiClient.get<WarehousesResponse>("/api/warehouses");
    const data = response.data as WarehousesResponse;
    // Поддерживаем оба формата
    if (Array.isArray(data)) return data;
    return data.warehouses;
  } catch (error) {
    console.error("Ошибка при получении списка складов:", error);
    throw new Error("Не удалось получить список складов");
  }
};

export const fetchWarehouseById = async (id: number): Promise<Warehouse> => {
  try {
    const response = await apiClient.get<Warehouse>(`/api/warehouses/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Ошибка при получении склада с ID ${id}:`, error);
    throw new Error(`Не удалось получить склад с ID ${id}`);
  }
};

